import { IMessageCodeMapping, IMessageData, IMessageMapping, TMessageCode, TMessageName } from '../../interfaces';
import { IMessageStrategy } from './interfaces';

class PlainMessageStrategy implements IMessageStrategy {
  constructor(private messages: IMessageMapping, private codeMapping: IMessageCodeMapping) {}

  /**
   * Insert data into template
   */
  private injectData(template: string, data: IMessageData, keyPrefix = '') {
    Object.keys(data).forEach((key) => {
      let tplKey = keyPrefix ? `${ keyPrefix }.${ key }` : `${ key }`;
      if (typeof data[key] === 'object' && data[key] !== null) {
        this.injectData(template, data[key], tplKey);
      }

      template = template.replace(`{{${ tplKey }}}`, data[key]);
    });

    template = template.replace('{{callback_params}}', encodeURIComponent(JSON.stringify(data)));

    return template;
  }

  getMessageByName(name: TMessageName, data?: IMessageData) {
    let messageText = this.messages[name] || this.messages.GENERAL_ERROR;

    if (data) {
      messageText = this.injectData(messageText, data);
    }

    return messageText;
  }

  getMessageNameByErrorCode(code: TMessageCode): TMessageName {
    return this.codeMapping[code] ?? this.getFallbackMessageName();
  }

  getFallbackMessageName() {
    return this.codeMapping.fallback;
  }
}

export default PlainMessageStrategy;
